import styled from 'styled-components';
import { select } from '../../core/themev2';

const TableContainer = styled.div`
  width: 100%;
  display: flex;
  max-height: ${({ device }) => (device !== 'mobile' ? '700px' : '500px')};
`;

const Table = styled.table`
  width: 100%;
  border-radius: 7px 7px 0px 0px !important;
  border-collapse: none;
  text-indent: initial;
  border-spacing: 0px !important;
  thead,
  tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
  }
`;

const Thead = styled.thead`
  width: 100%;
  height: 54px;
  border-radius: 7px 7px 0px 0px;
  background: ${select('middleGray')};
  color: ${select('black')};
  font-family: Hind;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
`;

const Tbody = styled.tbody`
  width: 100%;
  max-height: ${({ device }) => (device !== 'desktop' ? '446px' : '490px')};
  table-layout: fixed;
  display: block;
  overflow-y: auto;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 8px;
    border-radius: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${select('midLightGray')};
    border-radius: 8px;
  }
  & tr > td {
    font-weight: ${({ columnName, device }) => (columnName !== 'name' && device === 'desktop' ? '400' : '500')};
  }
`;

const Tr = styled.tr`
  width: 100%;
  :nth-child(even) {
    background-color: ${select('lightGray')};
  }
`;

const Td = styled.td`
  padding-left: 16px;
  width: auto;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: ${({ device }) => (device !== 'desktop' ? '12px' : '16px')};
  label {
    margin-left: 34%;
  }
  :first-child {
    width: ${({ device }) => {
      if (device === 'tablet') return '44%';
      if (device === 'mobile') return '60%';
      return '54%';
    }};
  }
  :last-child {
    padding-left: ${({ device }) => {
      if (device !== 'mobile') return '10%';
      return '16px';
    }};
    padding-right: 16px;
  }
`;

const NameContainer = styled.div`
  width: auto;
`;

const SpanResponsible = styled.span`
  width: auto;
  padding-left: 8px;
  color: ${select('midDarkGray')};
  font-family: Hind;
  font-size: ${({ device }) => (device !== 'desktop' ? '12px' : '16px')};
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export { TableContainer, Table, Thead, Tbody, Tr, Td, NameContainer, SpanResponsible };
